import 'webpack-jquery-ui'
import 'webpack-jquery-ui/resizable'
import 'webpack-jquery-ui/sortable'
import $ from 'jquery'
import spectrum from 'spectrum-colorpicker2'
import fineUploader from 'fine-uploader/lib/jquery/traditional'
import ace from 'ace-builds/src-min-noconflict/ace'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light-border.css'
import Alpine from 'alpinejs'

// import './_elis/resizer'

/* TypeScript */
import { App } from 'app'
import { Loader } from 'component'

/* JavaScript */
import { resizetrigger } from './_elis/resizer'

import * as appFunctions from './_elis/$_functions'
import * as responsiveMenu from './_elis/responsive_menu'
import * as mentions from './_elis/mentionTextarea'

import { client } from './_elis/client'
import { number } from './utils'

if ($) {
	$.extend({ spectrum })
	$.extend({ fineUploader })
}

window.jQuery = $
window.$ = $
window.Cookies = Cookies
window.Alpine = Alpine

// Nette Forms
// window.Nette = Nette // přidáno do layout jako link na www jinak nefunguje toggle ve fromulářích

// Settings
window.blockAttributeData = {}

// Ace
window.ace = ace

// App functions
window.show = appFunctions.show
window.debounce = appFunctions.debounce
window.makeDebounceAjaxCall = appFunctions.makeDebounceAjaxCall
window.resizetrigger = resizetrigger
window.Loader = Loader
// Responsive menu
window.app = responsiveMenu.app

window.formatNumber = number.formatNumber

window.mentionTextArea = mentions.mentionTextArea
window.mentionHighlight = mentions.mentionHighlight

// Src export
window.Swal = Swal

/**
 * Create new ELIS scripts instance -> Init
 */
try {
	client()
	const app = App()
	app.init()
} catch (e) {
	throw Error(e)
}
